<template>
  <div class="finance-refund">
    <div class="ly-card">
      <el-tabs v-model="refund_status" @tab-click="tabClick">
        <el-tab-pane label="申请单" name="refund_apply" v-if="hasPermission('refund_apply')"></el-tab-pane>
        <el-tab-pane label="已同意" name="refund_agree" v-if="hasPermission('refund_agree')"></el-tab-pane>
        <el-tab-pane label="已完成" name="refund_finish" v-if="hasPermission('refund_finish')"></el-tab-pane>
        <el-tab-pane label="已拒绝" name="refund_refuse" v-if="hasPermission('refund_refuse')"></el-tab-pane>
      </el-tabs>
      <div class="hd">
        <ul class="list">
          <li class="m-r-30">
            <div class="title">交易时间</div>
            <div class="content">
              <el-date-picker
                v-model="date"
                type="daterange"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd HH:mm:ss"
                :default-time="['00:00:00', '23:59:59']"
                :picker-options="pickerOptions"
              ></el-date-picker>
            </div>
          </li>
          <li>
            <div class="title">订单号</div>
            <div class="content">
              <el-input placeholder="订单号" v-model="form.order_number"></el-input>
            </div>
          </li>
        </ul>
        <div class="bottom">
          <el-button type="primary" @click.native="search">查询</el-button>
          <el-button type="primary" @click.native="exportExcel">导出</el-button>
        </div>
      </div>
    </div>
    <div class="ly-card">
      <ly-table
        :getTableData="getTableData"
        :tableHeader="tableHeader"
        :searchFormData="searchFormData"
        ref="lyTable"
        class="width-full"
        v-show="PERMISSION.length"
      >
        <template v-slot:action="row">
          <el-button @click.native="detail(row)" type="text" size="mini">详情</el-button>
          <template v-if="row.refund_status === 1">
            <el-button @click.native="agree(row)" v-loading="loading" type="text" size="mini">同意</el-button>
            <el-button @click.native="refuse(row)" type="text" class="el-button--danger" size="mini">拒绝</el-button>
          </template>
          <el-button @click.native="finish(row)" type="text" size="mini" v-if="row.refund_status === 2">完成</el-button>
        </template>
      </ly-table>
    </div>
    <order-inf-list :defData="defData" ref="orderInfo"></order-inf-list>
  </div>
</template>
<script>
import { DatePicker, Input, Tabs, TabPane } from 'element-ui';
import LyTable from '@/components/LyTable';
import OrderInfList from '@/components/OrderInfList';
import { financeRefundTable } from '@/utils/tableHeader';
import { finance } from '@/api';
import perMixin from '@/utils/perMixin';
import utils from '@/utils/utils';

export default {
  name: 'FinanceRefund',
  mixins: [perMixin],
  components: {
    ElTabs: Tabs,
    ElTabPane: TabPane,
    ElDatePicker: DatePicker,
    ElInput: Input,
    LyTable,
    OrderInfList
  },
  data() {
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近半年',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
              picker.$emit('pick', [start, end]);
            }
          }
        ]
      },
      date: '',
      form: {
        refund_status: '',
        order_number: ''
      },
      refund_status: '',
      getTableData: finance.getRefundList,
      searchFormData: {},
      refundKeys: ['refund_apply', 'refund_agree', 'refund_finish', 'refund_refuse'],
      tableHeader: financeRefundTable,
      defData: {},
      loading: false
    };
  },
  methods: {
    exportExcel() {
      finance
        .exportRefund({
          params: this.searchFormData
        })
        .then(data => {
          if (data) utils.downloadData(data, '退款列表');
        });
    },
    tabClick() {
      this.form.refund_status = this.refundKeys.indexOf(this.refund_status) + 1;
      this.search();
    },
    getAllowPer() {
      if (this.PERMISSION.length) {
        this.form.refund_status = this.refundKeys.indexOf(this.PERMISSION[0]) + 1;
        this.refund_status = this.refundKeys[this.form.refund_status - 1];
        this.search();
      }
    },
    search() {
      let tmp = {};
      if (this.date && this.date.length) {
        const [first_time, last_time] = this.date;
        tmp = {
          first_time,
          last_time
        };
      }
      this.searchFormData = { ...this.form, ...tmp };
      this.$refs.lyTable.setData();
    },
    changeMore() {
      this.isMore = !this.isMore;
      this.form = {
        pay_type: []
      };
    },
    detail(row) {
      this.$refs.orderInfo.open();
      finance
        .refundDetail({
          id: row.id
        })
        .then(res => {
          if (res) {
            this.defData = res.data.detail;
          }
        });
    },
    async agree(row) {
      this.loading = false;
      this.$confirm('确认同意退款?', '提示', {
        type: 'warning'
      })
        .then(() => {
          this.loading = true;
          finance
            .agreeRefund({
              id: row.id
            })
            .then(res => {
              this.loading = false;
              if (res) {
                this.$message.success(res.msg || '已同意！');
                this.search();
              }
            })
            .catch(() => {
              this.loading = false;
            });
        })
        .catch(() => {});
    },
    finish(row) {
      finance
        .accomplishRefund({
          id: row.id,
          params: {
            reason: '无'
          }
        })
        .then(res => {
          if (res) {
            this.$message.success(res.msg || '已完成！');
            this.search();
          }
        });
    },
    refuse(row) {
      finance
        .refuseRefund({
          id: row.id
        })
        .then(res => {
          if (res) {
            this.$message.success(res.msg || '已拒绝！');
            this.search();
          }
        });
    }
  }
};
</script>
<style lang="less">
.finance-refund {
  .el-input {
    width: 350px;
  }
  .hd {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .el-tabs__item {
    font-size: 16px;
  }
  ul.list {
    padding: 0;
    margin: 0;
    li {
      list-style: none;
      display: flex;
      align-items: center;
      float: left;
      .title {
        margin-right: 20px;
        min-width: 80px;
      }
    }
  }
  .bottom {
    min-width: 150px;
  }
}
</style>
